import { ICategorys, ISoftData } from "@/common/interface";
import Link from "@/components/common/Link";
import SoftBtn from "@/components/common/SoftBtn";
import classnames from "classnames";
import React from "react";
import ContentLoader from "react-content-loader";
import Img from "@/components/common/Img";
import "./index.scss";
import { OpenType } from "@q/softCore";

interface IProps {
  className?: "soft-cell--lg" | "soft-cell-md" | "soft-cell-sm" | string;
  showBtn?: boolean;
  supportLink?: boolean;
  data: ISoftData;
  description?: React.ReactNode;
  position?: string;
}

const SoftCell = (props: IProps) => {
  const {
    className = "soft-cell--sm",
    showBtn = false,
    supportLink = false,
    position,
    data: {
      url,
      soft_id,
      icon,
      name,
      desc,
      open_first,
      open_type,
      exec,
      href,
      btn_text,
      ads,
      category,
      clktk,
    },
    description,
  } = props;

  const configData = {
    open_first,
    open_type,
    exec,
    href,
    btn_text,
    ads,
    category,
  };

  const _desc = description || desc;

  if (!soft_id) {
    return (
      <div className={className}>
        <ContentLoader height={72} width={210} speed={2}>
          <rect x="0" y="0" rx="5" ry="5" width="70" height="70" />
          <rect x="85" y="10" rx="5" ry="5" width="100" height="6.4" />
          <rect x="85" y="35" rx="5" ry="5" width="100" height="6.4" />
          <rect x="85" y="52" rx="5" ry="5" width="100" height="6.4" />
        </ContentLoader>
      </div>
    );
  }

  const linkConfig =
    supportLink || !soft_id
      ? {
          open_type: open_type || OpenType.openDetailInHome,
          exec,
          href,
        }
      : {
          open_type: OpenType.openDetailInHome,
        };

  const categoryText =
    category && category.length > 0
      ? `${ICategorys[category]}`
      : `${ICategorys[1]}`;

  return (
    <Link
      className={classnames("soft-cell", className)}
      softId={soft_id}
      openType={linkConfig.open_type}
      exec={linkConfig.exec}
      href={linkConfig.href}
      dataText={categoryText}
      ads={ads}
      comAds={clktk}
      name={name}
      position={position}
      category={category}
    >
      <Img
        className="soft-cell__img"
        src={url || icon}
        title={name}
        type="logo"
      />
      <div className="soft-cell__info">
        <h3 className="soft-cell__title text-overflow" title={name}>
          {name}
        </h3>
        {_desc ? <p className="soft-cell__desc">{_desc}</p> : null}
        {showBtn ? (
          <SoftBtn
            className="soft-cell__btn"
            softId={soft_id}
            name={name}
            configData={configData}
            position={position}
            comAds={clktk}
          />
        ) : null}
      </div>
    </Link>
  );
};

export default SoftCell;
